import { render } from "./productH.vue?vue&type=template&id=398d4ab1&scoped=true"
import script from "./productH.vue?vue&type=script&lang=js"
export * from "./productH.vue?vue&type=script&lang=js"

import "./productH.vue?vue&type=style&index=0&id=398d4ab1&scoped=true&lang=less"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398d4ab1"]])

export default __exports__